export const isMobileWeb = () => {
  if (typeof window !== 'undefined') {
    return window.top === window
  }

  return false
}
